module.exports = __webpack_public_path__ + "static/media/backward.48a290eb.svg";